// extracted by mini-css-extract-plugin
export default {"cls1":"VeloPhoneNumberField-CountryCodeContainer_cls1__Gz+xA","cls2":"VeloPhoneNumberField-CountryCodeContainer_cls2__aerhS VeloPhoneNumberField-CountryCodeContainer_cls1__Gz+xA"};